"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageStringFromNavigatorObject = function (nav) {
    var hasLanguages = nav.languages && nav.languages.length > 0;
    var firstLanguage = hasLanguages && nav.languages[0].split('-')[0];
    var navLang = nav.language && nav.language.split('-')[0];
    return firstLanguage || navLang || undefined;
};
exports.getLocaleFromBrowserLanguage = function (nav) {
    var availableLocales = ['en'];
    var defaultLocale = availableLocales[0];
    var browserLanguage = exports.getLanguageStringFromNavigatorObject(nav);
    return !browserLanguage || !availableLocales.includes(browserLanguage)
        ? defaultLocale
        : browserLanguage;
};
//# sourceMappingURL=language.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/language/language.js
// module id = 301
// module chunks = 0